<label
	class="select-box"
	tuiLabel
>
	<tui-textfield
		class="select"
		tuiChevron
		tuiTextfieldSize="s"
		[content]="currentValue() ? itemContent : ''"
		[tuiTextfieldCleaner]="false"
	>
		@if (control()) {
			<input
				tuiSelect
				[formControl]="formControl()"
			/>
		} @else {
			<input
				tuiSelect
				[ngModel]="value()"
				(ngModelChange)="valueChange.emit($event)"
			/>
		}

		<tui-data-list-wrapper
			new
			*tuiTextfieldDropdown
			[items]="items()"
			[itemContent]="itemContent"
		/>
	</tui-textfield>
</label>

<ng-template
	#itemContent
	let-item
>
	{{ getLabel(item) | translate }}
</ng-template>
